export default defineNuxtPlugin(() => {
  const op = useOpenPanel()
  const envVars = useRuntimeConfig()
  const router = useRouter()
  const { data: session } = useAuth()
  const { isInternalUser } = useCurrentUserSession()

  if (isInternalUser) { return }

  op.setGlobalProperties({
    app_version: envVars.public.VERSION,
    environment: envVars.public.ENVIRONMENT
  })

  op.identify({
    profileId: session?.value?.user?.roles?.['x-hasura-user-id'] || 'no user detected',
    email: session?.value?.user?.email || 'no email detected',
    firstName: session?.value?.user?.givenName || 'no first name detected',
    lastName: session?.value?.user?.familyName || 'no last name detected',
    properties: {
      org: session?.value?.user?.roles?.['x-hasura-user-org'] || 'no org detected'
    }
  })

  router.afterEach(() => {
    op.track('$pageview')
  })
})
